import { managerInstance } from "libs/api";
import { CompanySection } from "modules/auth";
import { DeliveryCompany } from "modules/deliveryCompanies";

export interface ManagerProfile {
  id: string;
  deliveryCompanyId: string;
  firstname: string;
  lastname: string;
  email: string;
  allowedSections: CompanySection[];
  avatar: { id: string; url: string } | null;
  isActive: boolean;
}

export interface ManagerMeResponse {
  manager: ManagerProfile;
  company: DeliveryCompany;
}

export const requestGetCurrentManagerProfile =
  async (): Promise<ManagerMeResponse> => {
    return await managerInstance.get("/company-manager/me");
  };
